import React from 'react';

import { Sansad2025 } from '../views';

const HelpCenterArticlePage = () => {
  return <Sansad2025/>;
};

export default HelpCenterArticlePage;